import React from 'react';
import { createSvgIcon } from '../Svg';

export default createSvgIcon(
  <path d="M28 3H11.2C8.89 3 7 4.89 7 7.2V40.8C7 43.11 8.89 45 11.2 45H36.4C38.71 45 40.6 43.11 40.6 40.8V15.6L28 3ZM32.2 28.2H15.4V24H32.2V28.2ZM28 36.6H15.4V32.4H28V36.6ZM25.9 17.7V6.15L37.45 17.7H25.9Z" />,
  'file'
);
